import axios from "axios";
import { WEB_ROUTES } from "../WebEncryption";
import {
  AddIdentifier,
  AddIdentifierVerification,
} from "../../Models/Request/Identifier/AddIdentifier";

export function getIdentifiers() {
  return axios.get(`/User/Identifiers`);
}

export function getMobileIdentifiers() {
  return axios.get(`/User/Identifiers/mobile`);
}

export function addIdentifier(body: AddIdentifier) {
  return axios.post(WEB_ROUTES.addIdentifier, body);
}

export function addIdentifierVerification(body: AddIdentifierVerification) {
  return axios.post(WEB_ROUTES.verifyIdentifier, body);
}

export const deleteIdentifier = (id: string) => {
  return axios.delete("/User/Identifiers", {
    data: JSON.stringify(id),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const verifyAndDeleteIdentifier = (request: {
  id: string;
  otpUniqueID: string;
  code: string;
}) => {
  return axios.post(
    WEB_ROUTES.deleteIdentifierVerify,
    request
  );
};
